import { connect } from 'react-redux';
import { About, IAboutProps } from '../../components/About';
import { getDescription, getNewbuildingDisplayName } from '../../selectors/newbuilding';
import { TApplicationState } from '../../types/redux';
import { trackOpenInfoAboutJK } from '../../actions/analytics';

type TAboutStateProps = Pick<IAboutProps, 'description' | 'displayName'>;

type TAboutDispatchProps = Pick<IAboutProps, 'trackActionOpenInfoAboutJK'>;

export function mapStateToProps(state: TApplicationState): TAboutStateProps {
  return {
    description: getDescription(state),
    displayName: getNewbuildingDisplayName(state),
  };
}

export function mapDispatchToProps(): TAboutDispatchProps {
  return {
    trackActionOpenInfoAboutJK: trackOpenInfoAboutJK,
  };
}

export const AboutContainer = connect(mapStateToProps, mapDispatchToProps)(About);
